import {useSubscription} from '~/api/deimos/billing'
import {PlanType} from '~/api/types/plan'
import {createBffHooks} from '~/bff'
import {useFlags, useFlagsLoaded} from '~/flags'
import {useUser} from '~/shell/user'
import type {UserData} from '~/shell/user'

import type {InviteUsersRouter} from '../backend/index.bff'

const requestAccessEnabledRole: Array<UserData['role']> = ['owner']
const freePlans: PlanType[] = [PlanType.FREE, PlanType.STARTER]

const bff = createBffHooks<InviteUsersRouter>().accessRequests

export const useAccessRequestsEnabled = () => {
    const user = useUser()
    const {data: subscription, isValidating: isSubscriptionLoading} = useSubscription(
        undefined,
        true,
    )
    const planType = subscription?.planSubscriptionItem?.plan?.type
    const hasAllowedRole = user?.role && requestAccessEnabledRole.includes(user.role)
    const {
        userAccessRequests: featureFlagEnabled,
        userAccessRequestsAllPlans: featureFlagEnabledForAllPlans,
        cardRequests: isCardRequestsEnabled,
    } = useFlags()
    const hasEligibleSubscription =
        featureFlagEnabledForAllPlans ||
        (!subscription?.isInTrial && planType && !freePlans.includes(planType))
    const flagsLoaded = useFlagsLoaded()
    const {data: isMultiEntity, error, isInitialLoading} = bff.getIsMultiEntity.useQuery()

    return {
        accessRequestsEnabled:
            hasAllowedRole &&
            featureFlagEnabled &&
            !isInitialLoading &&
            !error &&
            (!isMultiEntity || isCardRequestsEnabled) &&
            hasEligibleSubscription,
        isLoading: isInitialLoading || !flagsLoaded || isSubscriptionLoading,
    }
}
